import { render, staticRenderFns } from "./SubstitutionModal.vue?vue&type=template&id=f1c7beb8"
import script from "./SubstitutionModal.vue?vue&type=script&lang=js"
export * from "./SubstitutionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports